module.exports = "<div class=\"ssf-message\" *ngIf=\"(messages$ | async) && (messages$ | async)?.length > 0\">\n    <alert *ngFor=\"let message of (messages$ | async)\" type=\"{{message.type}}\">\n        {{message.message | translate}}\n    </alert>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/messages/messages.component.html
// module id = 635
// module chunks = 3